export const defaultTaxRegisState = {
	TaxRegisData: [],
	Total: 0,
	hadRegisteredDeclaration: false //Cờ đánh dấu đã đăng ký tờ khai thuế nộp qua mạng nào chưa true-rồi false-chưa
};

export default {
	...defaultTaxRegisState
};
